<div style="width: 100%; display: flex; justify-content: center; align-items: center; flex-direction: column;">
    <div style="padding-top: 90px;" class="welcomeText">
        <h3>{{dataJson['Ueberschrift']}} <b><span>{{dataJson['UeberschriftStyle']}}</span></b></h3>
        <div class="price-center">
        <div class="price-overdiv">
            <div style="padding-top: 0;">
                <h4>{{dataJson['ZweitUeberschrift']}}</h4>
                <span style="text-align: center;"><b>{{dataJson['SubTitle']}}</b></span>
            </div>
            <div>
                <h5>{{dataJson['Block1Ueberschrift']}}</h5>
                <span [innerHTML]="dataJson['Block1Text1']"></span>
                <span [innerHTML]="dataJson['Block1Text2']"></span>
                <span [innerHTML]="dataJson['Block1Text3']"></span>
            </div>
            <div>
                <h5>{{dataJson['Block2Ueberschrift']}}</h5>
                <span [innerHTML]="dataJson['Block2Text1']"></span>
                <span [innerHTML]="dataJson['Block2Text2']"></span>
                <span [innerHTML]="dataJson['Block2Text3']"></span>
                <span [innerHTML]="dataJson['Block2Text4']"></span>
                <span [innerHTML]="dataJson['Block2Text5']"></span>
                <span [innerHTML]="dataJson['Block2Text6']"></span>
            </div>
            <div>
                <h5>{{dataJson['Block3Ueberschrift']}}</h5>
                <span><b>{{dataJson['Block3SubTitle']}}</b></span>
                <span [innerHTML]="dataJson['Block3Text1']"></span>
                <!-- <div class="price-list" style="padding-top: 16px;">
                    <div class="price-item" *ngFor="let item of priceList">
                      <div class="item-description">{{item.description}}</div>
                      <div class="item-price">{{item.price}}</div>
                    </div>
                </div> -->
                <app-price-pre style="padding-top: 40px; padding-bottom: -20px;" [priceComp]="true"></app-price-pre>
                <span>{{dataJson['StandDatum']}}</span>
            
            </div>
            <div>
                <h5><u>{{dataJson['AbrechnungUeberschrift']}}</u></h5>
                <h6>{{dataJson['block4Ueberschrift']}}</h6>
                <span [innerHTML]="dataJson['Block4Text1']"></span>
                <h6>{{dataJson['block5Ueberschrift']}}</h6>
                <span [innerHTML]="dataJson['Block5Text1']"></span>
                <h6>{{dataJson['Block6Ueberschrift']}}</h6>
                <span [innerHTML]="dataJson['Block6Text1']"></span>
                <h6>{{dataJson['Block7Ueberschrift']}}</h6>
                <span [innerHTML]="dataJson['Block7Text1']"></span>
                <h6>{{dataJson['Block8Ueberschrift']}}</h6>
                <span [innerHTML]="dataJson['Block8Text1']"></span>
                <span [innerHTML]="dataJson['Block8Text2']"></span>
                <h6>{{dataJson['Block9Ueberschrift']}}</h6>
                <span [innerHTML]="dataJson['Block9Text1']"></span>
            </div>
        </div>
    </div> 
</div>


<app-contact-pre></app-contact-pre>